import './index.less'
import { Alert } from 'antd';
import PropTypes from 'prop-types';
import React, { Component } from 'react'



export default class DynamicMsg extends Component {
	static propTypes = {
       show: PropTypes.bool.isRequired,
       onClose: PropTypes.func.isRequired,
	   message: PropTypes.string.isRequired,
    };

	constructor(props) {
		super(props)
	}

	render () {
		let { show, onClose, message } = this.props
		return show ? <Alert className="mention-info" message={message} type="info" showIcon closable onClose={onClose}/> : null
	}
}
